import React from 'react';
import { withRouter } from 'react-router-dom';
import Suspense from '../../Common/components/Suspense-component';
import { getSinglePharmacyAppearance, getSingleService } from '../epics-pharmacies';
import EditService from '../component-edit-service';

class EditPharmacyServicePage extends React.Component {
    getSinglePharmacyAppearance = () => {
        return getSinglePharmacyAppearance(this.props.match.params.pharmacyId);
    };

    getServiceDetails = () => {
        return getSingleService(this.props.match.params.pharmacyId, this.props.match.params.serviceId);
    };

    render() {
        return (
            <Suspense
                apiCalls={{
                    selectedService: this.getServiceDetails,
                    appearance: this.getSinglePharmacyAppearance
                }}
            >
                <EditService />
            </Suspense>
        );
    }
}

export default withRouter(EditPharmacyServicePage);



// WEBPACK FOOTER //
// ./src/customModules/Pharmacies/containers/container-edit-service.js